import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./css/levels.css";
import { useQuiz } from "providers/QuizProvider";

const GameDetails = () => {
  const { activeQuiz } = useQuiz();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="home">
      <div className="main">
        <div className="container-fluid box-wrapper difficult">
          <div className="page-header pb-4">
            <div className="box-wrapper mx-auto text-center position-relative header-container">
              <button type="button" className="icon-button" onClick={() => navigate(-1)}>
                <img src="/image/back.png" className="arrow" alt="back" />
              </button>
              <span className="game-title">{activeQuiz?.name}</span>
            </div>
          </div>
          <div className="quiz-thumbnail">
            <img src={activeQuiz?.image} alt="Quiz" />
          </div>
          <div className="quiz-info">
            <div className="">
              <div className="row quiz-info-row gx-1">
                <div className="col-6">
                  <h3 className="section-title2 mb-3">
                    {activeQuiz?.name} {t("15")}
                  </h3>
                </div>
                <div className="col-6 quiz-info-meta2">
                  <span className="quiz-info-meta-circle-img">
                    <img src="/image/Group 19.png" alt="Quiz" />
                  </span>
                  <span className="title-gap">10 {t("16")}</span>
                </div>
                {/* <div className="col-6 quiz-info-meta2">
                                    <span className="quiz-info-meta-circle-img"><img src="/image/Group 3.png" alt="Quiz" /></span>
                                    <span className='title-gap'>100 Points</span>
                                </div> */}
              </div>
            </div>
            <div className="quiz-info-content">
              <h4 className="quiz-info-content-title">{t("18")}</h4>
              <p>{activeQuiz?.description}</p>
            </div>

            <NavLink to="/levels" className="btn btn-lg button-primary w-100">
              {t("19")}
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameDetails;
